import React from 'react';
import PropTypes from 'prop-types';
import AuthenticationController from '../controllers/AuthenticationController';
import StringUtil from '../util/StringUtil';
import Modal from '../modals/Modal';
import $ from 'jquery';
import CreateNewUser from './../queries/user/CreateNewUser';
import { Logger } from './../logger/Logger';
import { togglePageLoadPlaceholder } from '../util/DOMUtil';
import { validateEmail } from '../form/validators';
import Img from '../common/elements/Img';
import _ from 'lodash';

import './NotLoggedBlock.css';
import RequestOTPForLogin from '../queries/user/RequestOTPForLogin';
import Authenticator from '../protocol/Authenticator';
import ThumbnailUtil from '../util/ThumbnailUtil';
import ParamsUtil from '../util/ParamsUtil';
import ResendPassCode from './ResendPassCode';
import t from '../i18n/I18n';
import I18nPopover from './I18nPopover';
import AuthMechanism, { NULL_BASIC_REALM } from '../auth/AuthMechanism';
import Authenticator2 from '../auth/Authenticator2';
import Store from '../store/Store';
import { getNotificationPermission } from '../basic/Notification';
import { ThemeSetup } from '../themes/ThemeSetup';
import System from '../basic/System';
import ConnectionUtil from '../util/session/ConnectionUtil';

export default class NotLoggedBlock extends React.Component {
  static LOGIN_SCREEN_STATE_CREATE_ACCOUNT: string = 'CREATE_ACCOUNT';
  static LOGIN_SCREEN_STATE_LOGIN: string = 'LOGIN';

  static propTypes = {
    backgroundImage: PropTypes.string,
    subtitle: PropTypes.string,
    fullHeight: PropTypes.bool,
    toggleSpinner: PropTypes.bool,
    resetSessionOnLoginFail: PropTypes.bool,
    isLinkUser: PropTypes.bool,
    onSignInComplete: PropTypes.func,
    onAuthMechanismChange: PropTypes.func
  };

  static defaultProps = {
    backgroundImage: 'url(images/login_background.jpg)',
    subtitle: 'PAGE_REQUIRES_LOGIN',
    fullHeight: true,
    toggleSpinner: true,
    resetSessionOnLoginFail: true,
    isLinkUser: false,
    onSignInComplete: $.noop
  };

  constructor(props) {
    super(props);
    this.logger = new Logger('NotLoggedBlock');
    this.profileFileId = '';
    this.profilePicName = '';
    this.notLoggedBlockRef = React.createRef();
  }

  state = {
    username: window.usernameForLogin ? window.usernameForLogin : '',
    password: '',
    error: null,
    currentScreen: window.entryScreen ? window.entryScreen : NotLoggedBlock.LOGIN_SCREEN_STATE_LOGIN, // LOGIN or CREATE_ACCOUNT
    passCode: '',
    email: window.emailIdForCreateAccount ? window.emailIdForCreateAccount : '',
    firstName: '',
    lastName: '',
    actPass: '',
    actPassConfirm: '',
    readTerms: false,
    uploadedFile: null,
    uploadedFileImgData: null,
    verificationLinkSendSuccess: false,
    verificationLinkSendError: null,
    verificationLinkSendInfo: null,
    modal: null,
    ifSignInProgress: false,
    isSignInButtonDisable: false,
    requestOTP: false,
    otp: '',
    otpSuccessMessage: '',
    resendPasscode: false,
    otpErrorMessage: '', // PRIVACY_POLICY
    sendingPassCode: false
  };

  componentDidMount() {
    if (this.props.toggleSpinner) {
      togglePageLoadPlaceholder(true);
    }

    if (window.errorMessageForLinkUser) {
      window.setError(window.errorMessageForLinkUser);
    }
    this.setState({ showLoginWithOAuthLink: Authenticator2.isOAuthMechanismAvailable() });
    getNotificationPermission();
    window.gs.updateNotLoggedInBlock = () => {
      this.forceUpdate();
    };
  }

  componentWillUnmount() {
    window.gs.updateNotLoggedInBlock = null;
    if (this.props.toggleSpinner) {
      togglePageLoadPlaceholder(false);
    }
  }

  sendLoginQuery = (e) => {
    if (e) {
      e.target.blur();
    }
    if (!this.state.ifSignInProgress) {
      this.login();
    }
  };

  renderI18nPopover = () => {
    return (
      <div className="I18nSelecter">
        <center>
          <I18nPopover />
        </center>
      </div>
    );
  };

  render() {
    const { fullHeight } = this.props;
    const backgroundImage = window.loginBgExists
      ? `url('${NotLoggedBlock.getLoginBackgroundImage()}')`
      : 'url(images/login_background.jpg)';

    return (
      <div name="NotLoggedBlock" ref={this.notLoggedBlockRef} style={{ height: fullHeight ? '100%' : '', minHeight: '100vh', backgroundImage }}>
       <div className="area area-top-left"></div>
       <div className="area area-top-mid"></div>
       <div className="area area-top-right"></div>
       <div className="area area-mid-left"></div>
       <div className="area area-mid-mid flex-col">
        {this.state.currentScreen === 'LOGIN' && this.renderLogin()}
          {this.state.currentScreen === 'CREATE_ACCOUNT' && this.renderCreateAccount()}
          {this.state.modal === 'PRIVACY_POLICY' && (
            <Modal
              title={t('PRIVACY_POLICY')}
              onClose={() => this.setState({ modal: null })}
              closeOnEsc
              closeOnOutsideClick>
              {t('PRIVACY_POLICY_TEXT')}
            </Modal>
          )}
          {this.renderI18nPopover()}
       </div>
       <div className="area area-mid-right"></div>
       <div className="area area-bottom-left"></div>
       <div className="area area-bottom-mid"></div>
       <div className="area area-bottom-right"></div> 
    </div>
    );
  }

  renderLogin() {
    const { subtitle } = this.props;
    const { ifSignInProgress, isSignInButtonDisable, requestOTP } = this.state;
    const signInButton = ifSignInProgress ? t('PLEASE_WAIT') : t('SIGN_IN');
    return (
      <div className="pane">
        <div
        className='header-lock'
          style={{
            // height: '100px',
            backgroundImage: ThemeSetup.getBackgroundURL('lock.svg'),
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center'
          }}
        />
        <div className="header">{System.isBrowserApp() ? t('WELCOME') : t('WELCOME_DESKTOP')}</div>
        <div className="subtitle">{t(subtitle)}</div>

        <div
          style={{ marginBottom: '10px', display: 'flex', border: 'var(--input-box-border-1)', borderRadius: '3px' }}>
          <div
            style={{
              backgroundColor: 'var(--input-group-background)',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              backgroundImage: 'url(images/user.svg)',
              height: '40px',
              width: '40px'
            }}
          />
          <input
            value={this.state.username}
            onKeyUp={(event) => (event.which === 13 ? this.sendLoginQuery(event) : null)}
            onChange={(event) =>
              this.setState({
                username: _.isString(event.target.value) ? event.target.value.toLowerCase() : event.target.value
              })
            }
            style={{
              flexGrow: '1',
              outline: 'none',
              padding: '10px',
              border: 'none',
              fontSize: '16px',
              letterSpacing: '0px',
              color: 'var(--input-box-font-color)',
              backgroundColor: 'var(--element-bg-color-1)'
            }}
            placeholder={System.isVAB() ? t('USERNAME') : t('USERNAME_OR_EMAIL')}
            autoFocus={window.usernameForLogin ? false : true}
          />
        </div>

        {!requestOTP ? (
          <div
            style={{ marginBottom: '10px', display: 'flex', border: 'var(--input-box-border-1)', borderRadius: '3px' }}>
            <div
              style={{
                backgroundColor: 'var(--input-group-background)',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundImage: 'url(images/password.svg)',
                height: '40px',
                width: '40px'
              }}
            />
            <input
              value={this.state.password}
              type="password"
              onKeyUp={(event) => (event.which === 13 ? this.sendLoginQuery(event) : null)}
              onChange={(event) => this.setState({ password: event.target.value })}
              style={{
                flexGrow: '1',
                outline: 'none',
                padding: '10px',
                border: 'none',
                fontSize: '16px',
                letterSpacing: '0px',
                color: 'var(--input-box-font-color)',
                backgroundColor: 'var(--element-bg-color-1)'
              }}
              placeholder={t('PASSWORD')}
              autoFocus={window.usernameForLogin ? true : false}
            />
          </div>
        ) : null}

        <div style={{ margin: '20px 0px' }} />
        {System.isVAB ? null : (
          <div
            onClick={() => this.onForgotPasswordClick()}
            style={{ ...styles.forgetLink, position: 'relative', display: 'flex', marginTop: '5px' }}>
            {t('FORGOT_PASSWORD')}
          </div>
        )}

        <div
          onClick={() => {
            !isSignInButtonDisable ? this.login() : null;
          }}
          style={{
            ...styles.button,
            marginBottom: '8px',
            backgroundColor: 'var(--primary-style-color)',
            color: 'var(--primary-header-bg)',
            opacity: isSignInButtonDisable ? '0.5' : 1
          }}
          ref="signInButton">
          {signInButton}
        </div>
        {System.isVAB() ? null : (
          <div
            onClick={() => {
              this.setState({ currentScreen: NotLoggedBlock.LOGIN_SCREEN_STATE_CREATE_ACCOUNT }, ()=>
                this.notLoggedBlockRef.current.style.gridTemplateRows = '1fr minmax(580px, auto ) 1fr'
              );
            }}
            style={{ ...styles.createAccountButton, color: 'var(--primary-style-color)' }}>
            <img
              src={ThemeSetup.getImageURL('icon_user_add_colored.svg')}
              style={{ width: 18, height: 18, marginRight: '10px', verticalAlign: 'middle' }}
            />
            {t('CREATE_ACCOUNT').toUpperCase()}
          </div>
        )}
        {this.renderWithOAuthLinkButton()}
      </div>
    );
  }

  renderCreateAccount() {
    let terms = t('READ_TERMS');
    let privacyPolicy = terms.substring(terms.lastIndexOf('{') + 1, terms.lastIndexOf('}'));
    let terms1 = terms.substring(0, terms.lastIndexOf('{'));
    let terms2 = terms.substring(terms.lastIndexOf('}') + 1);
    let termsLabel = (
      <label htmlFor="readTerms">
        {terms1}{' '}
        <span
          style={{ color: '#EB6A5C', cursor: 'pointer' }}
          onClick={() => this.setState({ modal: 'PRIVACY_POLICY' })}>
          {privacyPolicy}
        </span>{' '}
        {terms2}
      </label>
    );
    let createAccountButtonText = t('VERIFY_EMAIL');
    let resetButtonText = t('RESET_FIELDS');
    let disableEmailField = false;
    if (window.emailIdForCreateAccount) {
      disableEmailField = true;
    }
    if (this.state.verificationLinkSendSuccess) {
      createAccountButtonText = t('CREATE_ACCOUNT');
    }
    return (
      <div className="pane create-account">
        <input
          type="file"
          accept="image/*"
          style={{ display: 'none' }}
          ref="profilePicUploader"
          onChange={(event) => this.handleFilePicker(event)}
        />
        <div
          style={{
            position: 'absolute',
            top: '15px',
            left: '15px',
            color: 'var(--secondary-font-color)',
            fontWeight: 600,
            fontSize: '14px',
            cursor: 'pointer'
          }}
          onClick={() => this.setState({ currentScreen: NotLoggedBlock.LOGIN_SCREEN_STATE_LOGIN }, 
          ()=> this.notLoggedBlockRef.current.style.gridTemplateRows = '')}>
          ← {t('BACK_TO_SIGN_IN')}
        </div>
        <div
          style={{
            height: '100px',
            backgroundImage: ThemeSetup.getBackgroundURL('lock.svg'),
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center'
          }}
        />
        <div style={styles.createAccount}>{t('CREATE_ACCOUNT')}</div>
        <div>
          <div
            onMouseMove={(event) => (this.refs.uploadArea.style.backgroundColor = 'rgba(235, 106, 92, 0.1)')}
            onMouseLeave={(event) => (this.refs.uploadArea.style.backgroundColor = '')}
            onDragEnter={(event) => (this.refs.uploadArea.style.backgroundColor = 'rgba(235, 106, 92, 0.1)')}
            onDragLeave={(event) => (this.refs.uploadArea.style.backgroundColor = '')}
            onDrop={(event) => this.onDropUploader(event)}
            onClick={() => this.refs.profilePicUploader.click()}
            ref="uploadArea"
            style={styles.uploadProfilePic}>
            {this.state.uploadedFileImgData ? (
              <div style={{ textAlign: 'center' }}>
                <img
                  src={this.state.uploadedFileImgData}
                  style={{ display: 'block', maxWidth: '200px', maxHeight: '200px', margin: '0 auto 10px auto' }}
                />
                {this.state.uploadedFile.name}{' '}
                <Img
                  title={t('REMOVE_PIC')}
                  onClick={(event) => {
                    this.setState({ uploadedFileImgData: null, profileFileId: '', profilePicName: '' });
                    event.stopPropagation();
                  }}
                  src="images/remove.svg"
                />
              </div>
            ) : (
              t('UPLOAD_PROFILE_PIC').toUpperCase()
            )}
          </div>
        </div>

        <div
          style={{ marginBottom: '10px', display: 'flex', border: 'var(--input-box-border-1)', borderRadius: '3px' }}>
          <div
            style={{
              backgroundColor: 'var(--input-group-background)',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              backgroundImage: 'url(images/icon_mail.svg)',
              height: '40px',
              width: '40px'
            }}
          />
          <input
            value={this.state.email}
            type="email"
            disabled={disableEmailField}
            onKeyUp={(event) => (event.which == 13 ? this.verifyFieldsCreateAccount() : null)}
            onChange={(event) => this.setState({ email: event.target.value })}
            style={{
              flexGrow: '1',
              outline: 'none',
              padding: '10px',
              border: 'none',
              fontSize: '16px',
              letterSpacing: '0px',
              color: 'var(--input-box-font-color)',
              backgroundColor: 'var(--element-bg-color-1)'
            }}
            placeholder={t('EMAIL')}
            autoFocus={window.emailIdForCreateAccount ? false : true}
          />
        </div>

        <div
          style={{ marginBottom: '10px', display: 'flex', border: 'var(--input-box-border-1)', borderRadius: '3px' }}>
          <div
            style={{
              backgroundColor: 'var(--input-group-background)',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              backgroundImage: 'url(images/user.svg)',
              height: '40px',
              width: '40px'
            }}
          />
          <input
            value={this.state.firstName}
            onKeyUp={(event) => (event.which == 13 ? this.verifyFieldsCreateAccount() : null)}
            onChange={(event) => this.setState({ firstName: event.target.value })}
            style={{
              flexGrow: '1',
              outline: 'none',
              padding: '10px',
              border: 'none',
              fontSize: '16px',
              letterSpacing: '0px',
              color: 'var(--input-box-font-color)',
              backgroundColor: 'var(--element-bg-color-1)'
            }}
            placeholder={t('FIRST_NAME')}
            autoFocus={window.emailIdForCreateAccount ? true : false}
          />
        </div>

        <div
          style={{ marginBottom: '10px', display: 'flex', border: 'var(--input-box-border-1)', borderRadius: '3px' }}>
          <div
            style={{
              backgroundColor: 'var(--input-group-background)',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              backgroundImage: 'url(images/user.svg)',
              height: '40px',
              width: '40px'
            }}
          />
          <input
            value={this.state.lastName}
            onKeyUp={(event) => (event.which == 13 ? this.verifyFieldsCreateAccount() : null)}
            onChange={(event) => this.setState({ lastName: event.target.value })}
            style={{
              flexGrow: '1',
              outline: 'none',
              padding: '10px',
              border: 'none',
              fontSize: '16px',
              letterSpacing: '0px',
              color: 'var(--input-box-font-color)',
              backgroundColor: 'var(--element-bg-color-1)'
            }}
            placeholder={t('LAST_NAME')}
          />
        </div>

        <div
          style={{ marginBottom: '10px', display: 'flex', border: 'var(--input-box-border-1)', borderRadius: '3px' }}>
          <div
            style={{
              backgroundColor: 'var(--input-group-background)',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              backgroundImage: 'url(images/password.svg)',
              height: '40px',
              width: '40px'
            }}
          />
          <input
            value={this.state.actPass}
            type="password"
            onKeyUp={(event) => (event.which == 13 ? this.verifyFieldsCreateAccount() : null)}
            onChange={(event) => this.setState({ actPass: event.target.value })}
            style={{
              flexGrow: '1',
              outline: 'none',
              padding: '10px',
              border: 'none',
              fontSize: '16px',
              letterSpacing: '0px',
              color: 'var(--input-box-font-color)',
              backgroundColor: 'var(--element-bg-color-1)'
            }}
            placeholder={t('PASSWORD')}
          />
        </div>

        <div
          style={{ marginBottom: '10px', display: 'flex', border: 'var(--input-box-border-1)', borderRadius: '3px' }}>
          <div
            style={{
              backgroundColor: 'var(--input-group-background)',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              backgroundImage: 'url(images/password.svg)',
              height: '40px',
              width: '40px'
            }}
          />
          <input
            value={this.state.actPassConfirm}
            type="password"
            onKeyUp={(event) => (event.which == 13 ? this.verifyFieldsCreateAccount() : null)}
            onChange={(event) => this.setState({ actPassConfirm: event.target.value })}
            style={{
              flexGrow: '1',
              outline: 'none',
              padding: '10px',
              border: 'none',
              fontSize: '16px',
              letterSpacing: '0px',
              color: 'var(--input-box-font-color)',
              backgroundColor: 'var(--element-bg-color-1)'
            }}
            placeholder={t('CONFIRM_PASSWORD')}
          />
        </div>

        {this.state.verificationLinkSendSuccess ? this.showEnterPassCode() : null}

        {/*<div style={{ marginBottom: '10px' }}>
         <input id='readTerms' checked={this.state.readTerms} type='checkbox' onChange={event => this.setState({ readTerms: event.target.checked })} />
         {termsLabel}
         </div>
         */}
        {this.state.verificationLinkSendError ? this.showVerificationSendLinkError() : null}
        {this.state.verificationLinkSendInfo ? this.showVerificationSendLinkInfo() : null}
        <div style={{ marginBottom: '30px', marginTop: '5px' }}>
          <div
            ref="resetButtonText"
            onClick={() => {
              this.resetFields();
            }}
            style={{
              color: '#7A7A7A',
              fontSize: '14px',
              lineHeight: '18px',
              cursor: 'pointer',
              letterSpacing: '1px',
              float: 'left'
            }}>
            {resetButtonText}
          </div>

          {this.state.resendPasscode && !this.state.verificationLinkSendError ? (
            <div
              style={{
                color: 'var(--secondary-font-color)',
                fontSize: '14px',
                lineHeight: '18px',
                float: 'right'
              }}>
              <div>
                {this.state.sendingPassCode ? (
                  <div>{t('SENDING')}...</div>
                ) : (
                  <ResendPassCode resendPassCode={this.resendPasscode} time={3} />
                )}
              </div>
            </div>
          ) : null}
        </div>
        <div
          ref="createAccountButtonText"
          onClick={() => {
            this.verifyFieldsCreateAccount();
          }}
          style={{
            ...styles.button,
            marginBottom: this.state.verificationLinkSendError ? '24px' : '8px',
            backgroundColor: 'var(--primary-style-color)',
            color: 'var(--primary-header-bg)',
            marginTop: '24px'
          }}>
          {createAccountButtonText}
        </div>
      </div>
    );
  }

  showOTPSuccessMessage = () => {
    return (
      <div style={styles.verificationInfo}>
        {this.state.otpSuccessMessage ? <label>{this.state.otpSuccessMessage}</label> : null}
      </div>
    );
  };

  showOTPErrorMessage = () => {
    return (
      <div style={styles.verificationError}>
        {this.state.otpErrorMessage ? <label>{this.state.otpErrorMessage}</label> : null}
      </div>
    );
  };

  onSuccessOfRequestOTP = (success) => {
    if (this.logger.isDebug()) {
      this.logger.debug('Send Verification Call Response:', success);
    }
    this.setState({
      otpSuccessMessage: t('OTP_SENT_ON_EMAIL')
    });
  };

  onFailureOfRequestOTP = (errorId) => {
    this.setState({
      otpErrorMessage: errorId.toString()
    });
  };

  handleRequestOTPForLogin = () => {
    this.setState({
      requestOTP: !this.state.requestOTP
    });
    if (!this.state.requestOTP) {
      const query = new RequestOTPForLogin();
      const promise = query.requestOTP(this.state.username);
      promise.then(this.onSuccessOfRequestOTP, this.onFailureOfRequestOTP);
    }
  };

  showVerificationSendLinkError() {
    return (
      <div style={styles.verificationError}>
        <label>{this.state.verificationLinkSendError}</label>
      </div>
    );
  }

  showVerificationSendLinkInfo() {
    return (
      <div style={styles.verificationInfo}>
        <label>{this.state.verificationLinkSendInfo}</label>
      </div>
    );
  }

  showEnterPassCode() {
    return (
      <div style={{ marginBottom: '10px', display: 'flex', border: '1px solid #E7E7E7' }}>
        <div
          style={{
            backgroundColor: '#3E3E3E',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundImage: 'url(images/key.svg)',
            backgroundSize: '20px 20px',
            transform: 'rotate(270deg)',
            height: '40px',
            width: '40px'
          }}
        />
        <input
          value={this.state.passCode}
          type="text"
          onKeyUp={(event) => (event.which === 13 ? this.verifyFieldsCreateAccount() : null)}
          onChange={(event) => this.setState({ passCode: event.target.value })}
          style={{
            flexGrow: '1',
            outline: 'none',
            padding: '10px',
            border: 'none',
            fontSize: '16px',
            letterSpacing: '0px'
          }}
          placeholder={t('INVITE_CODE')}
          autoFocus={true}
        />
      </div>
    );
  }

  renderUploadedFile() {
    if (this.state.uploadedFile == null) return null;
    return <img />;
  }

  onDropUploader(event) {
    //Todo: What is user uploaded a txt file or a folder. Still add check for null even or files length.
    try {
      const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
      if (event.dataTransfer.files && event.dataTransfer.files.length === 1) {
        this.profileImageFile = event.dataTransfer.files[0];
        if (this.profileImageFile.type.substr(0, 5) === 'image' && allowedExtensions.exec(this.profileImageFile.name)) {
          this.showPreviewOfUploadProfilePic(this.profileImageFile, event);
          this.setState({
            verificationLinkSendError: null
          });
        } else {
          this.setState({
            verificationLinkSendError: t('VERIFICATION_IMAGE_FILE_ERROR')
          });
        }
      }
    } catch (e) {
      console.warn(e);
      this.logger.warn(e.message);
    }
  }

  showPreviewOfUploadProfilePic(file, event) {
    if (file) {
      let dataTransferFile = file;
      //event.target.style.backgroundColor = '';
      this.setState({ uploadedFile: dataTransferFile });
      let reader = new FileReader();
      reader.onloadend = () => this.setState({ uploadedFileImgData: reader.result });
      reader.readAsDataURL(dataTransferFile);
    }
  }

  uploadImageAndCreateAccount(file) {
    let fileExtension = file.name.split('.').pop();
    this.getSessionIdOfUploadImage(file, fileExtension);
  }

  handleFilePicker(event) {
    try {
      const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
      if (event.target.files && event.target.files.length === 1) {
        this.profileImageFile = event.target.files[0];
        if (this.profileImageFile.type.substr(0, 5) === 'image' && allowedExtensions.exec(this.profileImageFile.name)) {
          this.showPreviewOfUploadProfilePic(this.profileImageFile, event);
          this.setState({
            verificationLinkSendError: null
          });
        } else {
          this.setState({
            verificationLinkSendError: t('VERIFICATION_IMAGE_FILE_ERROR')
          });
        }
      }
    } catch (e) {
      console.warn(e);
      this.logger.error(e.message);
    }
  }

  getSessionIdOfUploadImage = (file, fileExtension) => {
    const url = ConnectionUtil.getPreviewServerUrl() + ThumbnailUtil.AVATAR_UPLOAD_PATH;
    let formData = new FormData();
    formData.append('profilePicFile', file);
    //Todo: What if upload is going on. Add check for profile pic size and dimension.
    //Todo Add todo on sever to check minimum dimension, We have todo scale up o down the image which user uploads.
    $.ajax({
      url: url,
      type: 'POST',
      processData: false,
      contentType: false,
      async: true,
      cache: false,
      data: formData,
      success: (response) => {
        //Todo: No need to call setState whenever it is not required. It is supposed to be called only when UI change is required. Else keep variables locally.
        //Todo: Reset the drop related variable value on drop failure and on drop
        if (response.success) {
          this.profileFileId = response.fileId;
          this.profilePicName = this.state.email + '.' + fileExtension;
          this.createAccountOfUser();
        } else {
          this.setState({ verificationLinkSendError: response.errorInfo });
        }
      },
      error: (errorId) => {
        window.setError(errorId.toString());
      }
    });
  };

  static getLoginBackgroundImage() {
    if (System.isDesktop()) return window.loginBgExists;
    return ThumbnailUtil.getLoginBackgroundImage();
  }

  getUniqueKey() {
    if (this.uniqueKey === undefined) {
      this.uniqueKey = `${Date.now()}_${_.random(100000)}`;
    }
    return this.uniqueKey;
  }

  login(password = this.state.password) {
    const { resetSessionOnLoginFail, isLinkUser } = this.props;
    let __validUsername = this.isUserNameValid(this.state.username);
    let __validPassword = this.isPasswordValid(password);

    if (!__validUsername && !__validPassword) NotLoggedBlock.showError(t('BOTH_REQUIRED'));
    else if (!__validUsername) NotLoggedBlock.showError(t('USERNAME_REQUIRED'));
    else if (!__validPassword) NotLoggedBlock.showError(t('PASSWORD_REQUIRED'));
    else {
      this.setState({
        ifSignInProgress: true,
        isSignInButtonDisable: true
      });
      let previousUserName = Authenticator.AUTH_DATA.username;
      let reloadWindow = false;
      if (previousUserName) {
        if (previousUserName !== this.state.username) {
          reloadWindow = true;
          // this check is use to prevent to call updateSetting in AuthenticationController
          // because it always fail due to incomplete ajax call by window.location.reload
          window.gs.pageReload = true;
        }
      }
      Authenticator.AUTHENTICATOR_INSTANCE.authRealm = NULL_BASIC_REALM;
      AuthenticationController.signin(this.state.username, password, resetSessionOnLoginFail)
        .then(() => {
          if (reloadWindow) {
            window.location.reload(true);
            return;
          }
          if (System.isVAB()) {
            window.ARGS.activeTab = 'ASSETS';
          }
          this.setState({ ifSignInProgress: false, isSignInButtonDisable: false });
          this.props.onSignInComplete(null);
        })
        .catch((err) => {
          this.setState({ ifSignInProgress: false, isSignInButtonDisable: false });
          this.props.onSignInComplete(err);
        });
    }
    window.entryScreen = '';
  }

  onForgotPasswordClick() {
    let __validUsername = this.isUserNameValid(this.state.username);
    if (!__validUsername) NotLoggedBlock.showError(t('USERNAME_REQUIRED'));
    else {
      this.issueRecoverPwd(this.state.username);
    }
  }

  issueRecoverPwdQuery(username) {
    const __url = NotLoggedBlock.RECOVER_PWD + '?username=' + username;
    $.ajax({
      contentType: false, //WC-272 Improper use of jquery ajax contentType on GET request
      crossDomain: true,
      method: 'GET',
      crossDomain: true,
      xhrFields: {
        withCredentials: true
      },
      url: __url
    })
      .done((data, textStatus, jqXHR) => {
        this.onResponseForRecoverPwd(data, jqXHR);
      })
      .fail((jqXHR, textStatus, errorThrown) => {
        this.onResponseForRecoverPwd(undefined, jqXHR);
      })
      .always(() => {});
  }

  issueRecoverPwd = (username) => {
    let url = ConnectionUtil.getPreviewServerUrl() + ThumbnailUtil.RECOVER_PASSWORD_URL;
    url = ParamsUtil.append(url, { username: username, appName: 'webclient' });
    $.ajax({
      method: 'GET',
      crossDomain: true,
      xhrFields: {
        withCredentials: true
      },
      url: url
    })
      .done((data, textStatus, jqXHR) => {
        this.onResponseForRecoverPwd(data, jqXHR);
      })
      .fail((jqXHR, textStatus, errorThrown) => {
        this.onResponseForRecoverPwd(undefined, jqXHR);
      })
      .always(() => {});
  };

  onResponseForRecoverPwd(data, jqXHR) {
    if (jqXHR && jqXHR.status === 200) {
      const resObj = data;
      this.evaluateResponseObj(resObj);
    } else {
      const respObj = data;
      this.evaluateResponseObj(respObj);
    }
  }

  evaluateResponseObj(resObj) {
    let msg = resObj.info;
    if (resObj.success) {
      NotLoggedBlock.showInfoMsg(msg);
    } else {
      msg = resObj.message;
      NotLoggedBlock.showError(msg);
    }
  }

  createAccount() {
    this.setState({ verificationLinkSendInfo: '' });
    if (!this.state.verificationLinkSendSuccess) {
      this.sendVerificationLink();
    } else {
      if (this.state.uploadedFileImgData) {
        this.uploadImageAndCreateAccount(this.profileImageFile);
      } else {
        this.createAccountOfUser();
      }
    }
    this.setState({ resendPasscode: true });
  }

  sendVerificationLink() {
    //Send verification passcode mail to entered email id.
    //If entered email id is not allowed to create account then error will be throws and "this.onSendVerificationLinkFailure" method is called.
    //If passcode sent is successful, then "this.onSendVerificationLinkSucces" is called.
    //Whomsoever modifies the UI now, has to add resent mail link. Like for the cased when user didn't receive the mail. Like resebt OTP.
    this.setState({
      verificationLinkSendSuccess: false,
      verificationLinkSendError: null,
      sendingPassCode: true
    });
    const createNewUser = new CreateNewUser();
    const promise = createNewUser.sendEmailVerificationLink(
      this.state.email,
      this.state.firstName,
      this.state.lastName
    );
    promise.then(this.onSendVerificationLinkSucces, this.onSendVerificationLinkFailure);
  }

  createAccountOfUser() {
    const createNewUser = new CreateNewUser();
    const promise = createNewUser.createUser(
      this.state.email,
      this.state.firstName,
      this.state.lastName,
      this.state.passCode,
      this.state.actPass,
      this.profileFileId,
      this.profilePicName
    );
    promise.then(this.onCreateUserSuccess, this.onCreateUserFailed);
  }

  verifyFieldsCreateAccount = () => {
    const _validPasscode = this.isValidValue(this.state.passCode);
    if (this.verifyFields()) {
      if (this.refs.createAccountButtonText.innerHTML === t('CREATE_ACCOUNT') && !_validPasscode) {
        this.setState({ verificationLinkSendError: t('INVITECODE_REQUIRED') });
      } else {
        this.createAccount();
      }
    }
  };

  verifyFields = () => {
    const _validFirstName = this.isValidValue(this.state.firstName);
    const _validLastName = this.isValidValue(this.state.lastName);
    const _validEmail = this.isValidEmail(this.state.email);
    const _validPassword = this.isValidValue(this.state.actPass);
    const _validConfirmPassword = this.isValidValue(this.state.actPassConfirm);
    const _passwordMatch = this.doesConfirmPasswordMatch(this.state.actPass, this.state.actPassConfirm);

    if (!_validEmail) {
      this.setState({ verificationLinkSendError: t('EMAIL_INVALID') });
      return false;
    } else if (!_validFirstName) {
      this.setState({ verificationLinkSendError: t('FIRSTNAME_REQUIRED') });
      return false;
    } else if (!_validLastName) {
      this.setState({ verificationLinkSendError: t('LASTNAME_REQUIRED') });
      return false;
    } else if (!_passwordMatch) {
      this.setState({ verificationLinkSendError: t('CONFIRM_PASSWORD_NOT_MATCH') });
      return false;
    } else if (!_validPassword) {
      this.setState({ verificationLinkSendError: t('PASSWORD_REQUIRED') });
      return false;
    } else if (!_validConfirmPassword) {
      this.setState({ verificationLinkSendError: t('CONFIRM_PASSWORD_REQUIRED') });
      return false;
    }
    return true;
  };

  resetFields() {
    this.setState({
      username: '',
      password: '',
      error: null,
      passCode: '',
      email: '',
      firstName: '',
      lastName: '',
      actPass: '',
      actPassConfirm: '',
      readTerms: false,
      uploadedFile: null,
      uploadedFileImgData: null,
      verificationLinkSendSuccess: false,
      verificationLinkSendError: '',
      verificationLinkSendInfo: '',
      modal: null,
      ifSignInProgress: false,
      isSignInButtonDisable: false,
      resendPasscode: false
    });
  }

  resendPasscode = () => {
    if (this.verifyFields()) {
      this.sendVerificationLink();
    }
  };

  onCreateUserSuccess = (success) => {
    //window.gs.infoMsg = "Account created successfully";
    this.setState({ currentScreen: NotLoggedBlock.LOGIN_SCREEN_STATE_LOGIN, username: this.state.email });
    //window.render();
    this.login(this.state.actPass);

    /*if (this.logger.isDebug()) {
     this.logger.debug("User create for email: ");
     }*/
  };

  onCreateUserFailed = (errorId) => {
    this.setState({
      verificationLinkSendError: errorId.toString()
      //resendPasscode:true
    });
  };

  onSendVerificationLinkSucces = (success) => {
    if (this.logger.isDebug()) {
      this.logger.debug('Send Verification Call Response:', success);
    }
    this.setState({
      verificationLinkSendSuccess: success,
      verificationLinkSendError: null,
      verificationLinkSendInfo: t('PASSCODE_SEND_CHECK_MAIL'),
      sendingPassCode: false
    });
  };

  onSendVerificationLinkFailure = (errorId) => {
    this.setState({ verificationLinkSendError: errorId.toString() });
  };

  isUserNameValid(username) {
    return StringUtil.isNotEmpty(username);
  }

  isPasswordValid(password) {
    return StringUtil.isNotEmpty(password);
  }

  static showError(error) {
    window.setError(error);
  }

  isValidValue = (value) => {
    return StringUtil.isNotEmpty(value);
  };

  doesConfirmPasswordMatch = (password, confirmPassword) => {
    return password === confirmPassword;
  };

  isValidEmail(email) {
    return validateEmail(email);
    // let filter = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    // return (filter.test(email));
  }

  static showInfoMsg(info) {
    window.gs.infoMsg = info;
    window.render();
  }

  renderWithOAuthLinkButton = () => {
    if (this.state.showLoginWithOAuthLink) {
      return (
        <div style={styles.loginWithOAuthLink}>
          <a href="#" onClick={this.switchToOAuthMechanism}>
            {t('LOGIN.LOGIN_WITH_OAUTH')}
          </a>
        </div>
      );
    } else {
      return null;
    }
  };

  switchToOAuthMechanism = (e: Event) => {
    e.preventDefault();
    this.props.onAuthMechanismChange(AuthMechanism.OAuth);
  };
}

const styles = {
  forgetLink: {
    height: '18px',
    color: '#7A7A7A',
    fontSize: '14px',
    lineHeight: '18px',
    textAlign: 'center',
    cursor: 'pointer',
    margin: '20px 0',
    letterSpacing: '1px',
    borderRadius: '2px',
    width: '160px'
  },
  otp: {
    height: '18px',
    color: '#7A7A7A',
    fontSize: '14px',
    lineHeight: '18px',
    textAlign: 'center',
    cursor: 'pointer',
    margin: '20px 0 20px 10px',
    letterSpacing: '1px',
    borderRadius: '2px'
  },
  button: {
    textAlign: 'center',
    cursor: 'pointer',
    borderRadius: '2px',
    padding: '10px',
    marginBottom: '10px',
    fontSize: '12px',
    letterSpacing: '1px',
    fontWeight: 600
  },
  createAccountButton: {
    textAlign: 'center',
    cursor: 'pointer',
    borderRadius: '2px',
    paddingTop: '10px',
    fontSize: '12px',
    letterSpacing: '1px',
    fontWeight: 600,
    width: '200px',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  uploadProfilePic: {
    color: 'var(--primary-style-color)',
    border: '1px dashed var(--primary-style-color)',
    padding: '20px 20px 20px 40px',
    marginBottom: '15px',
    textAlign: 'center',
    position: 'relative',
    cursor: 'pointer',
    fontSize: '12px',
    fontWeight: '600',
    letterSpacing: '1px',
    lineHeight: '15px'
  },
  verificationError: {
    // width: '420px',
    color: '#DF2714',
    fontFamily: 'Montserrat',
    fontSize: '16px',
    lineHeight: '18px',
    wordWrap: 'break-word'
  },
  verificationInfo: {
    // width: '420px',
    color: '#797979',
    fontFamily: 'Montserrat',
    fontSize: '16px',
    lineHeight: '18px',
    wordWrap: 'break-word'
  },
  createAccount: {
    height: '24px',
    //width: '480px',
    color: 'var(--input-group-background)',
    fontFamily: 'Montserrat',
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px',
    textAlign: 'center'
  },
  loginWithOAuthLink: {
    fontSize: '13px',
    textAlign: 'center',
    margin: '8px'
  }
};

NotLoggedBlock.RECOVER_PWD = '/review/jsp/login/recoverPassword.jsp';
